import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import ResponsiveAppBar from '../../component/ResponsiveAppBar';
import Footer from '../../component/Footer';
import PendingEvaluation from '../PendingEvaluation';
import OpenedServiceRequest from '../OpenedServiceRequest';

import { signOut } from '../../store/slice/authSlice';
import { clearDataHome } from '../../store/slice/homeSlice';

const Home = () => {

  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [value, setValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleLogout = () => {
    dispatch(clearDataHome());
    dispatch(signOut());
    navigate('/login');
  };

  return (

    <Box component='section' sx={{ bgcolor: 'background.main' }}>

      <ResponsiveAppBar
        isLoading={isLoading}
        user={auth.user}
        companyId={auth.company && auth.company.id}
        onLogout={handleLogout}
      />
      
      <Container maxWidth='xl' sx={{ height: '90vh'}} disableGutters>

        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center',
          alignItems: 'center', 
          marginBottom: 1
        }}>

          <Tabs
            indicatorColor='secondary'
            value={value}
            onChange={handleChange}
            variant='scrollable'
            scrollButtons='auto'
          >
          
            <Tab 
              label='Abertas' 
              disabled={isLoading}  
            />
            
            <Tab 
              label='Avaliações' 
              disabled={isLoading}   
            />

          </Tabs>

        </Box>

        {value === 0?
          <OpenedServiceRequest
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
          : null
        }

        {value === 1?
          <PendingEvaluation
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
          : null
        }

        <Footer/>

      </Container>

    </Box>

  );
};

export default Home;